import { useResponseHandler } from '@hooks/useResponseHandler';
import { useSession } from '@hooks/useSession';

import {
  useGetAuthorizationUrlQuery,
  useGetDirectEmrIntegrationsQuery,
  useGetEmrConnectionsQuery,
} from 'generated/emr.generated';
import type {
  EmrConnectionInput,
  GetEmrIntegrationsInput,
} from 'generated/types';

export const useGetDirectEMRIntegrations = (
  params?: GetEmrIntegrationsInput
) => {
  const { handleError } = useResponseHandler();
  const {
    state: { activeProfile },
  } = useSession();
  const response = useGetDirectEmrIntegrationsQuery({
    variables: {
      input: params,
    },
    skip: !activeProfile,
  });
  handleError(response.error);
  return { ...response, data: response.data?.listDirectEmrApiIntegrations };
};

export const useGetEMRConnections = (params: { vitall_patient_id: string }) => {
  const { handleError } = useResponseHandler();
  const { vitall_patient_id } = params;
  const response = useGetEmrConnectionsQuery({
    variables: { input: { vitall_patient_id } },
    skip: !vitall_patient_id,
  });
  handleError(response.error);
  return { ...response, data: response.data?.listDirectEmrApiConnections };
};

export const useGetAuthorizationUrl = (params: EmrConnectionInput) => {
  const { fhir_api_endpoint_id, vitall_patient_id } = params;
  const response = useGetAuthorizationUrlQuery({
    variables: { input: { fhir_api_endpoint_id, vitall_patient_id } },
    skip: !fhir_api_endpoint_id,
    fetchPolicy: 'no-cache',
  });
  return { ...response, data: response.data?.getDirectEmrApiAuthorizationURL };
};
